import TradeDetails from './RewardTrade';
import Feature from './RewardFeature';
import NewUser from './RewardNewUser';
import TabContainer from '../TabContainer';
import { Tab, useTab } from '../useTab';
import * as S from './styles';
import RewardDaily from './RewardDaily';

const RewardContent = () => {
  const { isActive, setCurrentTab } = useTab();

  return (
    <S.Container>
      <S.TabContainer>
        <TabContainer isActive={isActive} setCurrentTab={setCurrentTab} />

        {isActive(Tab.NewUserReward) && <NewUser />}
        {isActive(Tab.DepositAndTradingVolumeReward) && <TradeDetails />}
        {isActive(Tab.FeatureExplorationMissions) && <Feature />}
        {isActive(Tab.DailyMission) && <RewardDaily/>}
      </S.TabContainer>
    </S.Container>
  );
};

export default RewardContent;
